export const normalizeSeqPayload = (payload: any, chatKey: string) => {
  let normalized = payload;
  if (payload && typeof payload === 'object' && typeof payload.Seq === 'number') {
    normalized = {
      chatId: payload.chatId ?? chatKey,
      seq: payload.Seq,
      content: payload.Content ?? payload.content ?? '',
      isFinal: payload.IsFinal ?? payload.isFinal,
    };
  }

  const parsedSeq = normalized?.seq;
  const seqValue = typeof parsedSeq === 'string' ? Number(parsedSeq) : parsedSeq;
  if (normalized && typeof normalized === 'object' && typeof normalized.chatId === 'string'
    && typeof seqValue === 'number' && !Number.isNaN(seqValue)) {
    return {
      targetChatId: normalized.chatId || chatKey,
      seq: seqValue,
      content: normalized.content ?? '',
      isFinal: normalized.isFinal,
    };
  }
  return null;
};
